<template>
  <section class="policy-holder">
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules">
      <div class="flex">
        <div class="flex-1">
          <template>
            <section :class="{'form-half':!isNewSme}">
              <div class="form-item">
                <span>Company Name</span>
                <el-form-item
                  ref="isrd_com_nm"
                  prop="isrd_com_nm">
                  <v-input
                    v-model="formData.isrd_com_nm"
                    uppercase
                    :disabled="checkDisabled('isrd_com_nm')" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Business Registration Number</span>
                <el-form-item
                  ref="id_no"
                  prop="id_no">
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    letterAndNumber
                    maxlength="8"
                    :disabled="checkDisabled('id_no')"
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Company Phone Number</span>
                <el-form-item
                  ref="phone_no"
                  prop="phone_no">
                  <v-input
                    v-model="formData.phone_no"
                    type="number"
                    :disabled="checkDisabled('phone_no')" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Company Email</span>
                <el-form-item
                  ref="email"
                  prop="email">
                  <v-input
                    v-model="formData.email"
                    :disabled="checkDisabled('email')" />
                </el-form-item>
              </div>
              <div v-if="!isNewSme">
                <span class="title">Company Address</span>
                <address-form
                  ref="address-form"
                  :isRequired="isRequired"
                  :formType="1"
                  :formDataLock="formDataLock"
                  :disabled="disabled"
                  :not-valid="isEdit"
                  :form="formData.corr_address"
                  @getFormData="getSubFormData" />
              </div>
              <div
                v-if="isNewSme"
                class="form-item">
                <span>Nature of Business</span>
                <el-form-item
                  ref="bsns_nature_id"
                  prop="bsns_nature_id">
                  <v-select
                    v-model="formData.bsns_nature_id"
                    :list="allOptions.industry" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Contact Person Name</span>
                <el-form-item
                  ref="contact_nm"
                  prop="contact_nm">
                  <v-input
                    v-model="formData.contact_nm"
                    :disabled="checkDisabled('contact_nm')" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Contact Person Mobile No.</span>
                <el-form-item
                  ref="contact_phone"
                  prop="contact_phone">
                  <v-input
                    v-model="formData.contact_phone"
                    type="number"
                    :disabled="checkDisabled('contact_phone')" />
                </el-form-item>
              </div>
            </section>
          </template>
        </div>
        <div
          v-if="isNewSme"
          class="flex-1">
          <div
            class="has-bold"
          >
            <div>
              <span class="title">Company Address</span>
              <address-form
                ref="address-form"
                :isRequired="isRequired"
                :formType="1"
                :formDataLock="formDataLock"
                :disabled="isNewSme?false:disabled"
                :form="formData.corr_address"
                @getFormData="getSubFormData" />
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <confirm-information
      ref="confirm-information"
      :upd_def_info="formData.updDefInfo"
      @confirm="handlerConfirmChangeInfo" />

  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinFormat from '@/mixins/format'
import AddressForm from '@/views/components/address-form'
import ConfirmInformation from '@/views/components/dialogs/confirm-information'
import dayjs from 'dayjs'
import {checkMobile} from '@/utils/validate'

export default {
  name: 'PolicyHolder',
  components: {
    AddressForm,
    ConfirmInformation
  },
  mixins: [MixinOptions, MixinRules, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    disabled:{
      type:Boolean,
      default:false
    },
    isEdit:{
      type:Boolean,
      default:false
    },
    isNewSme:{
      type:Boolean,
      default:false
    }
  },
  data() {
    const checkBirth3 = (rule, value, callback) => {
      let {pcy_cmnt_dt} = this.form
      const birth = dayjs(pcy_cmnt_dt).format('YYYY-MM-DD') || ( Date.now() + 1000 * 60 * 60 * 24)
      let msTime = new Date(value).getTime()
      let above18 = dayjs(value).add(18, 'year').format('YYYY-MM-DD')
      // if(msTime > Date.now()) {
      //   callback( new Error( '出生日期不得大於當前日期' ) )
      // }
      if(new Date(above18).getTime() > new Date(birth).getTime()) {
        callback( new Error('申請人必須年滿18歲' ) )
      }
      callback()
    }
    const checkIsEmail = (rule, value, callback) => {
      let {cust_typ} = this.form
      if(cust_typ!=1&&!val){
        callback( new Error(this.$t('placeholder.input')) )
      }
      callback()
    }
    const checkIdNo = (rule, value, callback) => {
      const { cust_typ, pp_no } = this.formData
      var reg = /[^\w\/]/
      if (cust_typ == 2 && value && reg.test(value)) {
        callback( new Error( '公司註冊證書編號最多为8位字母和數字' ) )
      }
      // else {
      //   if(!pp_no && !value) {
      //     callback(new Error(this.$t('placeholder.input')))
      //   }
      // }
      callback()
    }
    return {
      oldFormDataLock: -1,
      formData: {
        updDefInfo: [],
        isrd_com_nm:'',
        id_no:'',
        phone_no:'',
        email:'',
        bsns_nature_id:'',
        corr_address:{
          addr_room: '',
          addr_floor: '',
          addr_block: '',
          addr_building: '',
          addr_street: '',
          addr_district: '',
          addr_area: '',
          addr_region: '',
        },
        contact_nm:'',
        contact_phone:'',
      },
      oldFormData: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        isrd_title: '',
        isrd_dob: '',
        id_type: '',
        occ_id: '',
        id_no: '',
        mobile_no: '',
        email: '',
        // phone_no: '',
        // 公司
        isrd_com_nm: '',
        ci_no: '',
        phone_no: '',
        bsns_nature_id: '',
        contact_nm: '',
        // contact_occ_id: '',
        contact_phone: '',
        // contact_email: ''
      },
      subForm: {
        'address-form': false
      },
      extraRules:{
        isrd_dob:[
          { validator: checkBirth3, trigger: ['blur'] }
        ],
        id_no: [
          { validator: checkIdNo, trigger: ['change', 'blur'] }
        ],
        contact_phone: [
          { validator: checkMobile, trigger: ['change', 'blur'] }
        ],
        // email: [
        //   { validator: checkEmail, trigger: ['change', 'blur'] },
        //   { validator: checkIsEmail, trigger: ['change', 'blur'] },
        //
        // ],
      }
    }
  },
  computed: {
    formRules() {
      let extraRules=this.extraRules
      return this.checkRefer ===2 ? this.rules : extraRules
    },
    type() {
      return this.formData.cust_typ
    },
    // 判斷是否二次投保
    disabledVirgin() {
      const { is_virgin } = this.formData
      return is_virgin === 1? false: true
    },
    localAllOptions() {
      const classId = this.formData.class_id
      if(classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${classId}`]
      }
    },
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      handler(val) {
        if(this.formDataLock !== this.oldFormDataLock) {
          // 觸發更新就賦值，避免二次更新
          this.oldFormDataLock = this.formDataLock
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = val[key]
              // 用于匹配是否更新了信息
              if(key in this.oldFormData) {
                this.oldFormData[key] = val[key]
              }
            }
          })
          let {corr_address} = val||{}
          Object.keys(corr_address).some(key => {
            // 用于匹配是否更新了信息
            if(key in this.oldFormData) {
              this.oldFormData[key] = val[key]
            }
          })
        }
        // Object.keys(this.formData).some(key => {
        //   if(key in val) {
        //     this.formData[key] = val[key]
        //   }
        // })
      }
    },
  },
  methods: {
    checkDisabled(field) {
      // const { disable_filed = [] } = this.form||{}
      const  disable_filed = ['isrd_com_nm','id_no','phone_no','email']
      return disable_filed.includes(field)
    },
    openConfirmDialog() {
      this.$refs['confirm-information'].changeDialog()
    },
    handlerConfirmChangeInfo(result) {
      this.$emit('confirm', result)
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      if(form=='address-form')
        this.formData.corr_address = Object.assign(this.formData.corr_address, data)
      else  this.formData = Object.assign(this.formData, data)
    },
    submitForm(formName) {
      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          // 校驗地址組件
          Object.keys(this.subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if(Object.values(this.subForm).some(item => item === false)) {
            return
          }
          const updDefInfo = this.handler().checkUpdateInfo()
          this.formData.updDefInfo = updDefInfo
          let params = JSON.parse(JSON.stringify(this.formData))
          this.$emit('getFormData', formName, params)
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
      //
    },
    submitFormNoVaild(formName){
      // 校驗地址組件
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitFormNoVaild(key)
      })
      let params = JSON.parse(JSON.stringify(this.formData))
      this.$emit('getFormData', formName, params)
    },
    handler() {
      return {
        checkUpdateInfo: () => {
          const checkList = [
            {
              id: 'email',
              name: 'Email'
            },
            // {
            //   id: 'occ_id',
            //   name: 'Occupation',
            // },
            {
              id: 'bsns_nature_id',
              name: 'Nature of Business',
            },
            {
              id: 'contact_nm',
              name: 'Contact Name',
            },
            // {
            //   id: 'contact_occ_id',
            //   name: 'Occupation & Position',
            // },
            {
              id: 'contact_phone',
              name: 'Contact Number',
            },
            // {
            //   id: 'contact_email',
            //   name: 'Contact Email'
            // }
          ]

          let updDefInfo = []
          checkList.some(item => {
            if(this.oldFormData[item.id] != this.formData[item.id]) {
              updDefInfo.push(item)
            }
          })

          const addressList = [
            'addr_room',
            'addr_floor',
            'addr_block',
            'addr_building',
            'addr_street',
            'addr_region',
            'addr_area',
            'addr_district'
          ]
          addressList.some(key => {
            if(this.oldFormData[key] != this.formData.corr_address[key]) {
              updDefInfo.push({
                id: 'mailing_address',
                name: 'Correspondence Address'
              })
              return true
            }
          })
          return updDefInfo
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-holder {
  // .label {
  //         display: block;
  //         margin-bottom: 5px;
  //         font-size: 14px;
  //         font-weight: 500;
  //         color: #616266;
  //     }
  .has-bold{
    border-radius: 6px;
    border: 1px solid #D1D5DA;
    padding: 15px;
    margin-left: 15px;
  }
  .edit-holder-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 20px;
    .card {
      padding-bottom: 40px;
    }
  }
  .title {
    display: block;
    padding-bottom: 15px;
    color: #616266;
    font-size: 20px;
    font-weight: 500;
  }
  .form-flex {
    display: flex;
    justify-content: space-between;
    & > .form-block {
      margin-right: 15px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .form-block {
    margin-bottom: 15px;
    & > span:first-child {
      display: block;
      padding-bottom: 5px;
      font-weight: 500;
      font-size: 14px;
    }
  }
}
</style>
